import { useI18n } from '@cascade/react/i18n';
import { Dialog, Icon, Text } from '@cascade/ui-library';
import classes from './InstallGuide.module.scss';
import type { TInstallGuideProps } from './InstallGuide.types.ts';

const STEPS = [
  ['arrow-up-from-bracket', 'install.guide.share'],
  ['square-plus', 'install.guide.add'],
  ['mobile-screen', 'install.guide.confirm'],
] as const;

export const InstallGuide = ({ onClose }: TInstallGuideProps) => {
  const { translate } = useI18n();

  return (
    <Dialog
      title={translate('install.guide.title')}
      open
      size='sm'
      closeLabel={translate('install.guide.close')}
      onClose={onClose}
    >
      <ol className={classes.steps}>
        {STEPS.map(([icon, key]) => (
          <li key={icon} className={classes.step}>
            <Icon type={icon} />
            <Text content={translate(key)} />
          </li>
        ))}
      </ol>
    </Dialog>
  );
};
